import { render, staticRenderFns } from "./NewsletterModal.vue?vue&type=template&id=830bbc70&scoped=true"
import script from "./NewsletterModal.vue?vue&type=script&lang=js"
export * from "./NewsletterModal.vue?vue&type=script&lang=js"
import style0 from "./NewsletterModal.vue?vue&type=style&index=0&id=830bbc70&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "830bbc70",
  null
  
)

export default component.exports